"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

exports.__esModule = true;

var videoplayer_device_1 = require("@svt/videoplayer-device");

var getUrlAndTransport = function getUrlAndTransport(streamingProtocol, streamInfo) {
  switch (streamingProtocol) {
    case 'dash':
      return {
        url: streamInfo.videoReferences.dashhbbtv,
        transport: 'dash'
      };

    case 'hls':
      return {
        url: streamInfo.videoReferences.hls,
        transport: 'directfile'
      };
  }
};

exports.createRxPlayerLoadOptions = function (streamInfo, baseOptions) {
  var preferred = videoplayer_device_1.getPreferredStreamingProtocol(window);

  if (preferred === null) {
    throw new Error('Browser is not supported');
  }

  var options = __assign({}, getUrlAndTransport(preferred, streamInfo), {
    manualBitrateSwitchingMode: 'seamless' // TODO: Remove when rx-player >= 3.9.0

  });

  if (typeof baseOptions.startPosition !== 'undefined') {
    options.startAt = {
      position: baseOptions.startPosition
    };
  }

  if (typeof baseOptions.autoPlay !== 'undefined') {
    options.autoPlay = baseOptions.autoPlay;
  } // If we just recevied video urls, the manifest might not exist yet.
  // The video url might give us 404s for a while, so we'll increase
  // the number of retries allowed on the manifest.


  if (streamInfo.secondsToLiveRetry === 0) {
    options.networkConfig = {
      manifestRetry: 50
    };
  }

  return options;
};

exports["default"] = exports.createRxPlayerLoadOptions;